import { Map } from "../components/Map";

export function PrintMap() {
  return <Map />;
}
